import { TIME_INTERVAL_MINS } from "constants/timeIntervalMins";
import isInteger from "lodash/isInteger";

/**
 * should get nearest rounded 15 mins, :00, :15, :30, :45
 * @param arg minutes
 * @example
 * getNextMins(0) // return 15
 * getNextMins(12) // return 15
 * getNextMins(32) // return 45
 * getNextMins(59) // return 0
 */
export function getNextMins(arg: number) {
  const res = arg / TIME_INTERVAL_MINS;

  if (isInteger(res)) {
    // since the :00 will not be exact :00, return next :15
    return TIME_INTERVAL_MINS * (res + 1);
  }

  return Math.ceil(res) * TIME_INTERVAL_MINS;
}
